export type MitarbeiterType = 'ACTIVE' | 'INACTIVE';

export class MitarbeiterResult {
  constructor({
    id,
    vorname,
    nachname,
    standort,
    bildUrl,
    type,
    personalnummer,
    extern,
  }: {
    id: string;
    vorname: string;
    nachname: string;
    standort: string;
    bildUrl: string | null;
    type: MitarbeiterType;
    personalnummer: string | null;
    extern: boolean;
  }) {
    this.id = id;
    this.vorname = vorname;
    this.nachname = nachname;
    this.standort = standort;
    this.bildUrl = bildUrl;
    this.type = type;
    this.personalnummer = personalnummer;
    this.extern = extern;
  }

  id: string;
  vorname: string;
  nachname: string;
  standort: string;
  bildUrl: string | null;
  type: MitarbeiterType;
  personalnummer: string | null;
  extern: boolean;
}

export class StandortResult {
  constructor({
    name,
    id,
    standortId,
  }: {
    name: string;
    id: string;
    standortId: string;
  }) {
    this.name = name;
    this.id = id;
    this.standortId = standortId;
  }

  readonly name: string;
  readonly id: string;
  readonly standortId: string;
}
